import { render, staticRenderFns } from "./DmDokumente.vue?vue&type=template&id=5b27d68c&scoped=true&"
import script from "./DmDokumente.vue?vue&type=script&lang=js&"
export * from "./DmDokumente.vue?vue&type=script&lang=js&"
import style0 from "./DmDokumente.vue?vue&type=style&index=0&id=5b27d68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b27d68c",
  null
  
)

export default component.exports